import './version';
export { WindowContext, WindowProvider, useDocument, useWindow } from '@fluentui/react-window-provider';
export type { WindowProviderProps } from '@fluentui/react-window-provider';
